import { render } from "./DadosAeroporto.vue?vue&type=template&id=0619d6e5"
import script from "./DadosAeroporto.vue?vue&type=script&lang=js"
export * from "./DadosAeroporto.vue?vue&type=script&lang=js"

import "../css/transporte.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__